<pdq-card variant="popover" color="white">
  <div class="card">
    <div class="card__header">
      <pdq-heading element="h5">Cart page</pdq-heading>
      <pdq-button
        [icon]="cartPageExpanded ? 'chevron_up' : 'chevron_down'"
        variant="ghost"
        plain="true"
        size="medium"
        iconColor="var(--on-surface-default)"
        (onClick)="toggleCartPage()"></pdq-button>
    </div>
    @if (cartPageExpanded) {
      <pdq-divider></pdq-divider>
      <div class="card__content">
        <div class="setting-row">
          <div class="setting-row__text">
            <span class="setting-row__title">Use Cart Page</span>
            <span class="setting-row__description"
              >When disabled: If a customer tries to navigate to the full cart page, they will be redirected to the
              homepage and the Smart Cart will be automatically opened.</span
            >
          </div>
          <pdq-slide-toggle
            [defaultValue]="formGroup.controls.cartPageAndProductForm.controls.useCartPage.value"
            (onToggle)="
              formGroup.controls.cartPageAndProductForm.controls.useCartPage.setValue($event)
            "></pdq-slide-toggle>
        </div>
      </div>
    }
  </div>
</pdq-card>

<pdq-card variant="popover" color="white">
  <div class="card">
    <div class="card__header">
      <pdq-heading element="h5">Button Design Settings</pdq-heading>
      <pdq-button
        [icon]="buttonDesignExpanded ? 'chevron_up' : 'chevron_down'"
        variant="ghost"
        plain="true"
        size="medium"
        iconColor="var(--on-surface-default)"
        (onClick)="toggleButtonDesign()"></pdq-button>
    </div>
    @if (buttonDesignExpanded) {
      <pdq-divider></pdq-divider>
      <div class="card__content">
        <pdq-input-color
          [formControl]="formGroup.controls.buttonDesign.controls.backgroundColor"
          label="Background Color"></pdq-input-color>
        <pdq-input-color
          [formControl]="formGroup.controls.buttonDesign.controls.textColor"
          label="Text Color"></pdq-input-color>
        <pdq-input-color
          [formControl]="formGroup.controls.buttonDesign.controls.hoverTextColor"
          label="Hover Color"></pdq-input-color>
        <pdq-input-color
          [formControl]="formGroup.controls.buttonDesign.controls.iconColor"
          label="Icon Color"></pdq-input-color>
        <div class="field">
          <span class="field__label">Corner Radius</span>
          <pdq-input-arrows
            [formControl]="formGroup.controls.buttonDesign.controls.cornerRadius"
            [min]="0"
            widthSize="fullwidth"></pdq-input-arrows>
        </div>
      </div>
    }
  </div>
</pdq-card>

<pdq-card variant="popover" color="white">
  <div class="card">
    <div class="card__header">
      <pdq-heading element="h5">Event Callbacks</pdq-heading>
      <pdq-button
        [icon]="eventCallbacksExpanded ? 'chevron_up' : 'chevron_down'"
        variant="ghost"
        plain="true"
        size="medium"
        iconColor="var(--on-surface-default)"
        (onClick)="toggleEventCallbacks()"></pdq-button>
    </div>
    @if (eventCallbacksExpanded) {
      <pdq-divider></pdq-divider>
      <div class="card__content">
        @for (callback of eventCallbacks; track callback.label) {
          <div class="callback-row">
            <pdq-checkbox [formControl]="callback.enabled" [label]="callback.label" labelSize="small"></pdq-checkbox>
            @if (callback.enabled.value) {
              <pdq-link
                label="Edit code"
                external="true"
                size="small"
                (onClick)="onEditCallbackCode(callback)"></pdq-link>
            }
          </div>
        }
      </div>
    }
  </div>
</pdq-card>

<pdq-card variant="popover" color="white">
  <div class="card">
    <div class="card__header">
      <pdq-heading element="h5">Custom CSS</pdq-heading>
      <pdq-button
        [icon]="customCssExpanded ? 'chevron_up' : 'chevron_down'"
        variant="ghost"
        plain="true"
        size="medium"
        iconColor="var(--on-surface-default)"
        (onClick)="toggleCustomCss()"></pdq-button>
    </div>
    @if (customCssExpanded) {
      <pdq-divider></pdq-divider>
      <div class="card__content">
        <div class="setting-row">
          <div class="setting-row__text">
            <span class="setting-row__title">Custom CSS</span>
            <span class="setting-row__description"
              >This CSS only applies inside the Smart Cart drawer, so it won't reach the rest of your storefront. If
              that is what you're after, use a code slot below. &#64;import is rejected on save. url() has to be a
              relative path, a data: URI, or https:. http: and javascript: are refused.</span
            >
          </div>
          <pdq-slide-toggle
            [defaultValue]="formGroup.controls.customCss.controls.enabled.value"
            (onToggle)="formGroup.controls.customCss.controls.enabled.setValue($event)"></pdq-slide-toggle>
        </div>
        @if (formGroup.controls.customCss.controls.enabled.value) {
          <div class="callback-row">
            <pdq-link label="Edit CSS" external="true" size="small" (onClick)="onEditCustomCss()"></pdq-link>
          </div>
        }
        @if (customCssError) {
          <span class="validation-error">{{ customCssError }}</span>
        }
      </div>
    }
  </div>
</pdq-card>

<pdq-card variant="popover" color="white">
  <div class="card">
    <div class="card__header">
      <pdq-heading element="h5">Code Slots</pdq-heading>
      <pdq-button
        [icon]="codeSlotsExpanded ? 'chevron_up' : 'chevron_down'"
        variant="ghost"
        plain="true"
        size="medium"
        iconColor="var(--on-surface-default)"
        (onClick)="toggleCodeSlots()"></pdq-button>
    </div>
    @if (codeSlotsExpanded) {
      <pdq-divider></pdq-divider>
      <div class="card__content">
        <span class="setting-row__description"
          >Drop your own HTML into fixed positions in the Smart Cart. Whatever you put here runs in the page exactly as
          you wrote it (markup, &lt;style&gt; and &lt;script&gt; included), so it can affect your whole storefront, not
          just the cart. Your code, your call: we don't filter it.</span
        >
        @for (slot of codeSlots; track slot.key) {
          <div class="callback-row">
            <pdq-checkbox [formControl]="slot.enabled" [label]="slot.label" labelSize="small"></pdq-checkbox>
            @if (slot.enabled.value) {
              <pdq-link label="Edit code" external="true" size="small" (onClick)="onEditCodeSlot(slot)"></pdq-link>
            }
          </div>
        }
      </div>
    }
  </div>
</pdq-card>

<pdq-card variant="popover" color="white">
  <div class="card">
    <div class="card__header">
      <pdq-heading element="h5">Override</pdq-heading>
      <pdq-button
        [icon]="overrideExpanded ? 'chevron_up' : 'chevron_down'"
        variant="ghost"
        plain="true"
        size="medium"
        iconColor="var(--on-surface-default)"
        (onClick)="toggleOverride()"></pdq-button>
    </div>
    @if (overrideExpanded) {
      <pdq-divider></pdq-divider>
      <div class="card__content">
        <div class="setting-row">
          <div class="setting-row__text">
            <span class="setting-row__title">Custom Template</span>
            <span class="setting-row__description"
              >Write the Smart Cart's markup yourself instead of building it in the editor. You'll need to check back
              for updates and keep your code working with the latest version.</span
            >
          </div>
          <pdq-slide-toggle
            [ignoreValueChangeOnToggle]="true"
            [defaultValue]="formGroup.controls.override.controls.customTemplate.controls.enabled.value"
            (onToggle)="onCustomTemplateToggle()"></pdq-slide-toggle>
        </div>
        @if (formGroup.controls.override.controls.customTemplate.controls.enabled.value) {
          <div class="callback-row">
            <pdq-link
              label="Edit code"
              external="true"
              size="small"
              (onClick)="onEditGlobalCustomTemplate()"></pdq-link>
          </div>
        }
      </div>
    }
  </div>
</pdq-card>
